import ReducerUtils                   from "../../../utils/ReducerUtils"
import Actions                        from "../../../model/constant/actions"

const FailedPush = ReducerUtils.createReducer<{status:boolean,message:string,code:number}>({status:false,message:null,code:null},{
  [Actions.FAILED_UPDATING_PACY_ACCOUNT] : (state,action) => ({status:action.status,message:action.message,code:action.code})
})

export default FailedPush
